var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail_content"},[_c('div',{staticClass:"detail_label"},[_vm._v("\n    "+_vm._s(_vm.titleLabel)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"corporation_info_label detail_label",domProps:{"textContent":_vm._s(_vm.valueLabel)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f4d8086","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/masterPanel/masterView/CorporationView/corporationComponents/valueLabelSection.vue
// module id = null
// module chunks = 